import { render, staticRenderFns } from "./EquipmentReceive.vue?vue&type=template&id=5966f548&scoped=true&"
import script from "./EquipmentReceive.vue?vue&type=script&lang=js&"
export * from "./EquipmentReceive.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentReceive.vue?vue&type=style&index=0&id=5966f548&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5966f548",
  null
  
)

export default component.exports